import React from 'react'
import { connect } from 'react-redux'
import { compose, withState, withHandlers } from 'recompose'
import { FormattedMessage } from 'react-intl'
import { fetchingState } from './../helpers/hocs.js'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import numeral from 'numeral'

import { check } from '../store/reducers/giftcards'

const GiftCardsCheck = ({ submit, pin, number, setData, checkProps, error, showCheckCard, setShowCheckCard, from }) => {
  return (
      <div className='GiftCardsCheck'>
        <div className='GiftCardsCheck__left'>
          <h1 className='Head GiftCards__title IsClickable' onClick={()=>setShowCheckCard(!showCheckCard)}>
            Проверка баланса
          </h1>
          {(showCheckCard || (from === 'checkContainer')) && <div className='Row GiftCards__Row'>
            <div className='GiftCards__col'>

              {/*<div className='GiftCards__row'>
                <p className='Text'>
                  Для проверки доступного количества средств на карте введите номер карты и ее пин-код
                </p>
              </div>*/}

              <div className='GiftCardsCheck__row'>
                <p className='Text'>
                  <input
                    type='number'
                    className="Form__field Form__field-number"
                    value={number}
                    placeholder="№ сертификата"
                    onInput={setData('number')}
                  />
                </p>
              </div>
              <div className='GiftCardsCheck__row'>
                <p className='Text'>
                  <input
                    type='number'
                    className="Form__field Form__field-number"
                    value={pin}
                    placeholder="Пин-код"
                    onInput={setData('pin')}
                  />
                </p>
              </div>
              <button className='Button Button_white' onClick={submit}>
                Проверить
              </button>
            </div>
            {/*<div className='GiftCards__col'>
              <p className='Text GiftCards__text'>
                {(checkProps && (checkProps.balance !== undefined)) ? ('Баланс: ' + checkProps.balance) : '' }
              </p>
              <p className='Text GiftCards__text'>
                { (checkProps && checkProps.expirationDate) ? ('Дата окончания действия: '+ moment(checkProps.expirationDate).format('DD.MM.YYYY')) : ''}
              </p>
              {error && <p className='Text GiftCards__text'>
                Ошибка
            </p>}
              {!error && checkProps && checkProps.error && <p className='Text GiftCards__text'>
                Карта не найдена или не является действующей
            </p>}
              
            </div>*/}
          </div>}


          </div>
          {(showCheckCard || (from === 'checkContainer')) && <div className='GiftCardsCheck__right'>
            <p className='Text GiftCardsCheck__text'>
              {(checkProps && (checkProps.denomination !== undefined)) ? ('Номинал: ' + numeral(checkProps.denomination).format('0,0') + ' руб.') : '' }
            </p>
            <p className='Text GiftCardsCheck__text'>
              { (checkProps && checkProps.expirationDate) ? ('Срок действия: до '+ moment(checkProps.expirationDate).format('DD.MM.YYYY')) : ''}
            </p>
            <p className='Text GiftCardsCheck__text'>
              {(checkProps && (checkProps.balance !== undefined)) ? ('Текущий баланс: ' + numeral(checkProps.balance).format('0,0') + ' руб.') : '' }
            </p>
            <p className='Text GiftCardsCheck__text'>
              {(checkProps && (checkProps.holded !== undefined)) ? ('Захолдировано: ' + numeral(checkProps.holded).format('0,0') + ' руб.') : '' }
            </p>
            <p className='Text GiftCardsCheck__text'>
              {(checkProps && (checkProps.used !== undefined)) ? ('Использовано: ' + numeral(checkProps.used).format('0,0') + ' руб.') : '' }
            </p>
            {error && <p className='Text GiftCardsCheck__text'>
              Ошибка
            </p>}
              {!error && checkProps && checkProps.error && <p className='Text GiftCardsCheck__text'>
                <FormattedMessage id='bid.invalid_giftcard' />
            </p>}

          </div>}

      </div>
  )
}

const mapStateToProps = state => ({
  currentLocale: state.intl.locale,
  ...state.giftcards//.checkProps,
})

const mapDispatchToProps = dispatch => bindActionCreators({ check }, dispatch)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('number', 'setNumber', ''),
  withState('pin', 'setPin', ''),
  withState('error', 'setError', false),
  withState('showCheckCard', 'setShowCheckCard', false),
  fetchingState({ multi: true }),
  withHandlers({
    setData: ({ setNumber, setPin }) => field => e => {//заполнение полей ввода
      e && e.preventDefault();
      (field === 'number') ? setNumber(e.target.value) : setPin(e.target.value)
    },
    submit: ({ number, pin, check, fetchingWrap, checkProps, noLoader = true, setError }) => async e => {//отправка данных для проверки
      e && e.preventDefault()

      if (number && pin) {
        let res = noLoader ? await check({ 'number': number, 'pin': pin })
          : await fetchingWrap(check.bind(this, { 'number': number, 'pin': pin }))
        if (res !== 200) {
          setError(true)
        } else {
          setError(false)
        }
      }
    }
  })
)(GiftCardsCheck)



// WEBPACK FOOTER //
// ./src/components/GiftCardsCheck.jsx